/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useSortBy, useTable, usePagination } from 'react-table';
import { useSticky } from 'react-table-sticky';
import IcomoonReact from 'icomoon-react';

import iconSet from '../../../../shared/images/teambuildr-selection.json';
import TBTooltip from '../../../../shared/components/TBTooltip/TBTooltip';
import Icon from '../../../../shared/_TBComponents/Icon';

const Styles = styled.div`
  align-items: flex-start;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  font-family: nunito sans;
  height: 100%;
  overflow: auto;
  pointer-events: auto;
  width: 100%;

  & .sticky {
    filter: blur(1.2px);
    margin: 25px 10px;
    overflow-x: auto;

    [data-sticky-td] {
      position: sticky;
    }

    tfoot {
      td:first-child {
        border-bottom-left-radius: 8px;
        left: 0;
        position: sticky;
      }
    }
  }

  .athleteColumnHeaderCell {
    border-bottom: none;
  }

  .athleteNameTitle {
    background-color: #F0F0F0;
    border-top-left-radius: 8px;
    color: #444444;
    font-family: 'Nunito Sans';
    font-size: 16px;
    font-weight: bold;
    max-width: 180px;
    min-width: 180px;
    position: relative;
    text-align: left;
  }

  .footerCells {
    color: #444444;
    font-family: 'Nunito Sans';
    font-size: 16px;
    font-weight: normal;

    :last-child {
      border-bottom-right-radius: 8px;
    }
  }

  .noHoverCategoryColumnTitleCell {
    background-color: #F0F0F0;
    border-right: 1px solid #BDBDBD1A;
    color: #444444;
    font-size: 16px;
    font-weight: bold;
    max-width: 270px;
    min-width: 270px;

    :last-child {
      border-top-right-radius: 8px;
    }
  }

  .noHoverCategoryColumnTitleCellFirst {
    background-color: #F0F0F0;
    border-right: 1px solid #BDBDBD1A;
    border-top-left-radius: 8px;
    color: #444444;
    font-size: 16px;
    font-weight: bold;
    max-width: 270px;
    min-width: 270px;
  }

  .rawValueTitle {
    background-color: #F0F0F0;
    color: #444444;
    font-family: 'Nunito Sans';
    font-size: 16px;
    font-weight: normal;
    white-space: nowrap;
  }

  table {
    border-collapse: separate;
    border-spacing: 0;

    th,
    td {
      background: white;
      border-bottom: 1px solid #E0E0E0;
      border-right: 1px solid #BDBDBD1A;
      margin: 0;
      padding: 15px;
      text-align: center;
    }

    tfoot {
      td:first-child {
        color: #444444;
        font-family: 'Nunito Sans';
        font-size: 16px;
        font-weight: normal;
        text-align: left;
      }

      tr:first-child {
        td {
          background: #FCFCFC;
          border-bottom: none;
          border-top: 1px solid #E0E0E0;
          height: 61px;
          min-height: 61px;
        }
      }

      tr:last-child {
        display: none;
      }
    }

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
  }
`;

const Table = ({
  columns,
  data,
  getCellProps,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    prepareRow,
    page,
  } = useTable({
    columns,
    data,
    initialState: { pageIndex: 0, pageSize: 5 },
  },
  useSticky,
  useSortBy,
  usePagination);

  return (
    <>
      <div id='reportTable' style={{ display: 'flex' }} className='sticky'>
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()} data-a-wrap>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps([
                      {
                        className: column.className,
                      },
                    ])}
                    data-cols-width='30'
                    data-a-wrap
                    data-f-bold
                    data-fill-color={column?.style?.fillColor || 'FF424242'}
                    data-b-a-s='thin'
                    data-b-a-c='FF000000'
                    data-f-color={column?.style?.fillColor ? 'FF000000;' : 'FFFFFFFF'}
                    data-a-h='center'
                    data-a-v='center'
                  >
                    {column.render('Header')}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? (
                            <IcomoonReact
                              iconSet={iconSet}
                              size={10}
                              color='black'
                              icon='down-arrow'
                              style={{ marginLeft: '5px' }}
                            />
                          )
                          : (
                            <IcomoonReact
                              iconSet={iconSet}
                              size={10}
                              color='black'
                              icon='up-arrow'
                              style={{ marginLeft: '5px' }}
                            />
                          )
                        : ''}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td
                      {...cell.getCellProps([
                        {
                          style: cell.column.style,
                        },
                        getCellProps(cell),

                      ])}
                      data-fill-color={getCellProps(cell)?.style?.fillColor || null}
                      data-f-color={getCellProps(cell)?.style?.fontColor}
                      data-b-a-s='thin'
                      data-b-a-c='FF000000'
                      data-a-wrap
                    >
                      {cell.render('Cell')}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            {footerGroups.map((group) => (
              <tr {...group.getFooterGroupProps()}>
                {group.headers.map((column) => <td data-a-wrap {...column.getFooterProps([{ className: 'footerCells' }])}>{column.render('Footer')}</td>)}
              </tr>
            ))}
          </tfoot>
        </table>
      </div>
    </>
  );
};

const VBTAnalysisTableNoData = ({
  dataRows,
}) => {
  const chartRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);

  const handleScroll = () => {
    /** targetting the sticky container div scroll properties */
    const scrollWidth = chartRef.current?.childNodes[0]?.scrollWidth;
    const offsetWidth = chartRef.current?.childNodes[0]?.offsetWidth;
    const scrollLeft = chartRef.current?.childNodes[0]?.scrollLeft;
    setIsScrollable(offsetWidth + scrollLeft !== scrollWidth);
  };

  useEffect(() => {
    if (chartRef.current) {
      const scrollWidth = chartRef.current.childNodes[0]?.scrollWidth;
      const offsetWidth = chartRef.current.childNodes[0]?.offsetWidth;
      const scrollLeft = chartRef.current.childNodes[0]?.scrollLeft;
      setIsScrollable(offsetWidth + scrollLeft !== scrollWidth);
    }
  }, []);

  const athleteNameColumn = [
    {
      Header: '',
      Footer: () => null,
      id: 'name',
      sticky: 'left',
      className: 'athleteColumnHeaderCell',
      columns: [
        {
          Header: 'Athlete',
          accessor: 'name',
          Footer: 'Group Average',
          className: 'athleteNameTitle',
          style: {
            /** style for the whole column
             * className is style for just the header
            */
            borderRight: '1px solid #E0E0E0',
            height: '58px',
            textAlign: 'left',
          },
          Cell: () => (
            <Icon
              icon='user'
              size='30px'
              styledProps={{
                alignContent: 'center',
                backgroundColor: '#EEEEEE',
                borderRadius: '50%',
                height: '40px',
                textAlign: 'center',
                width: '40px',
              }}
            />
          ),
        },
      ],
    },
  ];

  const NoDataColumn = [
    {
      Header: () => 'Set 1',
      Footer: () => null,
      id: 'set1',
      className: 'noHoverCategoryColumnTitleCellFirst',
      columns: [
        {
          Header: 'Reps',
          accessor: 'reps',
          Cell: () => (
            <TBTooltip
              textContainerPadding='0px'
              textContainerMaxWidth='90px'
              textToDisplay='-'
              textToHover='-'
              fontColor='black'
              fontSize='12px'
            />
          ),
          Footer: '-',
          id: 'reps1',
          className: 'rawValueTitle',
          style: {
            fillColor: 'FFBDBDBD1A',
            fontWeight: 700,
            maxWidth: '90px',
            minWidth: '90px',
          },
        },
        {
          Header: 'Load',
          accessor: 'load',
          Cell: () => (
            <TBTooltip
              textContainerPadding='0px'
              textContainerMaxWidth='90px'
              textToDisplay='-'
              textToHover='-'
              fontColor='black'
              fontSize='12px'
            />
          ),
          Footer: '-',
          id: 'load1',
          className: 'rawValueTitle',
          style: {
            fillColor: 'FFBDBDBD1A',
            fontWeight: 700,
            maxWidth: '90px',
            minWidth: '90px',
          },
        },
        {
          Header: 'Avg. Velocity',
          accessor: 'avgVel',
          Cell: () => (
            <TBTooltip
              textContainerPadding='0px'
              textContainerMaxWidth='90px'
              textToDisplay='-'
              textToHover='-'
              fontColor='black'
              fontSize='12px'
            />
          ),
          Footer: '-',
          id: 'avgVel1',
          className: 'rawValueTitle',
          style: {
            fillColor: 'FFBDBDBD1A',
            fontWeight: 700,
            maxWidth: '90px',
            minWidth: '90px',
          },
        },
      ],
    },
    {
      Header: () => 'Set 2',
      Footer: () => null,
      id: 'set2',
      className: 'noHoverCategoryColumnTitleCell',
      columns: [
        {
          Header: 'Reps',
          accessor: 'reps',
          Cell: () => (
            <TBTooltip
              textContainerPadding='0px'
              textContainerMaxWidth='90px'
              textToDisplay='-'
              textToHover='-'
              fontColor='black'
              fontSize='12px'
            />
          ),
          Footer: '-',
          id: 'reps2',
          className: 'rawValueTitle',
          style: {
            fontWeight: 700,
            minWidth: '90px',
            maxWidth: '90px',
            fillColor: 'FFBDBDBD1A',
          },
        },
        {
          Header: 'Load',
          accessor: 'load',
          Cell: () => (
            <TBTooltip
              textContainerPadding='0px'
              textContainerMaxWidth='90px'
              textToDisplay='-'
              textToHover='-'
              fontColor='black'
              fontSize='12px'
            />
          ),
          Footer: '-',
          id: 'load2',
          className: 'rawValueTitle',
          style: {
            fontWeight: 700,
            minWidth: '90px',
            maxWidth: '90px',
            fillColor: 'FFBDBDBD1A',
          },
        },
        {
          Header: 'Avg. Velocity',
          accessor: 'avgVel',
          Cell: () => (
            <TBTooltip
              textContainerPadding='0px'
              textContainerMaxWidth='90px'
              textToDisplay='-'
              textToHover='-'
              fontColor='black'
              fontSize='12px'
            />
          ),
          Footer: '-',
          id: 'avgVel2',
          className: 'rawValueTitle',
          style: {
            fontWeight: 700,
            minWidth: '90px',
            maxWidth: '90px',
            fillColor: 'FFBDBDBD1A',
          },
        },
      ],
    },
    {
      Header: () => 'Set 3',
      Footer: () => null,
      id: 'set1',
      className: 'noHoverCategoryColumnTitleCell',
      columns: [
        {
          Header: 'Reps',
          accessor: 'reps',
          Cell: () => (
            <TBTooltip
              textContainerPadding='0px'
              textContainerMaxWidth='90px'
              textToDisplay='-'
              textToHover='-'
              fontColor='black'
              fontSize='12px'
            />
          ),
          Footer: '-',
          id: 'reps3',
          className: 'rawValueTitle',
          style: {
            fontWeight: 700,
            minWidth: '90px',
            maxWidth: '90px',
            fillColor: 'FFBDBDBD1A',
          },
        },
        {
          Header: 'Load',
          accessor: 'load',
          Cell: () => (
            <TBTooltip
              textContainerPadding='0px'
              textContainerMaxWidth='90px'
              textToDisplay='-'
              textToHover='-'
              fontColor='black'
              fontSize='12px'
            />
          ),
          Footer: '-',
          id: 'load3',
          className: 'rawValueTitle',
          style: {
            fontWeight: 700,
            minWidth: '90px',
            maxWidth: '90px',
            fillColor: 'FFBDBDBD1A',
          },
        },
        {
          Header: 'Avg. Velocity',
          accessor: 'avgVel',
          Cell: () => (
            <TBTooltip
              textContainerPadding='0px'
              textContainerMaxWidth='90px'
              textToDisplay='-'
              textToHover='-'
              fontColor='black'
              fontSize='12px'
            />
          ),
          Footer: '-',
          id: 'avgVel3',
          className: 'rawValueTitle',
          style: {
            fontWeight: 700,
            minWidth: '90px',
            maxWidth: '90px',
            fillColor: 'FFBDBDBD1A',
          },
        },
      ],
    },
  ];

  const columns = [...athleteNameColumn, ...NoDataColumn];

  const memoizedColumns = React.useMemo(
    () => columns,
    [dataRows],
  );
  const memoizedDataRows = React.useMemo(
    () => dataRows,
    [dataRows],
  );

  return (
    <>
      <Styles
        ref={chartRef}
        onScroll={handleScroll}
        isScrollable={isScrollable}
      >
        <Table
          columns={memoizedColumns}
          data={memoizedDataRows}
          getCellProps={() => ({
            style: {
              backgroundColor: 'FFFFFFFF',
              color: 'FF444444',
              fillColor: 'FFFFFFFF',
              fontColor: 'FF444444',
            },
          })}
        />
      </Styles>
    </>
  );
};

export default VBTAnalysisTableNoData;
